<template>
    <div id="produk">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Pembayaran',
                    to: { path: '/produk' },
                    exact: true,
                },
                { text: 'Transaksi' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <div>
            <v-row>
                <v-col cols="12" md="10">
                    <h3 class="header-text font-weight-bold">Transaksi</h3>
                </v-col>

                <v-cols cols="12" md="2" class="align-right">
                    <div class="text-right mt-5">
                        <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-width="120"
                            offset-x
                        >
                            <template
                                v-slot:activator="{ on, attrs }"
                                class="text-right"
                            >
                                <span style="font-size: 16px">
                                    Filter &nbsp;&nbsp;</span
                                >
                                <v-btn
                                    depressed
                                    color="white"
                                    v-bind="attrs"
                                    v-on="on"
                                    width="120"
                                >
                                    <span class="blew--text">
                                        <span v-if="filter_type === 'ALL'"
                                            >Semua</span
                                        >
                                        <span v-if="filter_type === 'CUSTOM'"
                                            >Custom</span
                                        >
                                        <v-icon color="blew" small class="ml-6">
                                            mdi-chevron-down
                                        </v-icon>
                                    </span>
                                </v-btn>
                            </template>

                            <v-card class="pt-7" width="350">
                                <v-card-title>
                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <div style="font-size: 14px">
                                                Rentang Tanggal
                                            </div>
                                            <div>
                                                <v-select
                                                    outlined
                                                    placeholder="Pilih Rentang Tanggal"
                                                    v-model="filter_type"
                                                    class="pa-0"
                                                    :items="[
                                                        {
                                                            text: 'Semua',
                                                            value: 'ALL',
                                                        },
                                                        {
                                                            text: 'Custom',
                                                            value: 'CUSTOM',
                                                        },
                                                    ]"
                                                ></v-select>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="filter_type === 'CUSTOM'">
                                        <v-col cols="12" md="12">
                                            <v-row>
                                                <v-col cols="12" md="6">
                                                    <div
                                                        style="font-size: 14px"
                                                    >
                                                        Dari Tanggal
                                                    </div>
                                                    <div>
                                                        <v-dialog
                                                            ref="dialog"
                                                            v-model="modal_date"
                                                            :return-value.sync="
                                                                date
                                                            "
                                                            persistent
                                                            width="290px"
                                                        >
                                                            <template
                                                                v-slot:activator="{
                                                                    on,
                                                                    attrs,
                                                                }"
                                                            >
                                                                <v-text-field
                                                                    v-model="
                                                                        date
                                                                    "
                                                                    outlined
                                                                    dense
                                                                    readonly
                                                                    v-bind="
                                                                        attrs
                                                                    "
                                                                    v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                v-model="date"
                                                                scrollable
                                                            >
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="
                                                                        modal_date = false
                                                                    "
                                                                >
                                                                    Cancel
                                                                </v-btn>
                                                                <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="
                                                                        $refs.dialog.save(
                                                                            date,
                                                                        )
                                                                    "
                                                                >
                                                                    OK
                                                                </v-btn>
                                                            </v-date-picker>
                                                        </v-dialog>
                                                    </div>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <div
                                                        style="font-size: 14px"
                                                    >
                                                        Sampai Tanggal
                                                    </div>
                                                    <div>
                                                        <v-dialog
                                                            ref="dialog2"
                                                            v-model="
                                                                modal_date2
                                                            "
                                                            :return-value.sync="
                                                                date2
                                                            "
                                                            persistent
                                                            width="290px"
                                                        >
                                                            <template
                                                                v-slot:activator="{
                                                                    on,
                                                                    attrs,
                                                                }"
                                                            >
                                                                <v-text-field
                                                                    v-model="
                                                                        date2
                                                                    "
                                                                    outlined
                                                                    dense
                                                                    readonly
                                                                    v-bind="
                                                                        attrs
                                                                    "
                                                                    v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                v-model="date2"
                                                                scrollable
                                                            >
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="
                                                                        modal_date2 = false
                                                                    "
                                                                >
                                                                    Cancel
                                                                </v-btn>
                                                                <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="
                                                                        $refs.dialog2.save(
                                                                            date2,
                                                                        )
                                                                    "
                                                                >
                                                                    OK
                                                                </v-btn>
                                                            </v-date-picker>
                                                        </v-dialog>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-title>
                                <v-card-actions class="pb-5 pr-3">
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        rounded
                                        depressed
                                        @click="menu = false"
                                    >
                                        Batal
                                    </v-btn>
                                    <v-btn
                                        rounded
                                        depressed
                                        color="primary"
                                        @click="doFilter()"
                                    >
                                        Terapkan
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-menu>
                    </div>
                </v-cols>
            </v-row>
        </div>

        <v-card>
            <v-card-title> Daftar Transaksi </v-card-title>
            <v-divider />
            <app-datatable
                :items="transaksiList"
                :headers="headers"
                :hasAction="false"
                :has-custom-search="true"
                :has-custom-pagination="true"
                :custom-pagination-total-items="params.total_transaction"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="pagination.totalPages"
                :custom-pagination-sort-mode="pagination.sortMode"
                :row-expanded-detail="rowDetail"
                :route-menu="'transaksi'"
                :loading="isLoading"
                v-on:selected="selectedRow = $event"
                v-on:deleted="deleteProduk($event)"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: $event.key.value };
                    doSearch();
                "
                v-on:loadDetailExpanded="loadDetailExpanded($event)"
            ></app-datatable>
        </v-card>

        <v-dialog
            v-model="showModal"
            transition="dialog-top-transition"
            width="471px"
            min-height="744px"
            max-height="744px"
            @click:outside="reset()"
            v-if="selectedRow"
            scrollable
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title width="100%">
                        Detail Transaksi
                        <v-spacer></v-spacer>
                        <v-btn small icon @click="dialog.value = false"
                            ><v-icon>mdi-close-circle</v-icon></v-btn
                        >
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pa-4">
                        <v-list-item>
                            <v-list-item-title class="font-weight-bold">
                                ID Transaksi
                            </v-list-item-title>
                            <v-list-item-title>
                                {{ selectedRow.id }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title class="font-weight-bold">
                                Email
                            </v-list-item-title>
                            <v-list-item-title>
                                {{ selectedRow.email }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item style="background-color: #fbfbfb">
                            <v-list-item-title class="font-weight-bold">
                                Nama Siswa
                            </v-list-item-title>
                            <v-list-item-title>
                                {{ selectedRow.nama_siswa }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title class="font-weight-bold">
                                Email
                            </v-list-item-title>
                            <v-list-item-title>
                                {{ selectedRow.email }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title class="font-weight-bold">
                                Sekolah
                            </v-list-item-title>
                            <v-list-item-title>
                                {{
                                    selectedRow.school
                                        ? selectedRow.school
                                        : "-"
                                }}</v-list-item-title
                            >
                        </v-list-item>
                        <v-list-item style="background-color: #fbfbfb">
                            <v-list-item-title class="font-weight-bold">
                                Nama Paket
                            </v-list-item-title>
                            <v-list-item-title>
                                {{ selectedRow.paket }}</v-list-item-title
                            >
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title class="font-weight-bold">
                                Nama Group
                            </v-list-item-title>
                            <v-list-item-title>
                                {{
                                    selectedRow.group ? selectedRow.group : "-"
                                }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title class="font-weight-bold">
                                Nominal
                            </v-list-item-title>
                            <v-list-item-title class="font-weight-bold">
                                {{
                                    selectedRow.nominal
                                        ? "Rp. " + selectedRow.nominal
                                        : "-"
                                }}</v-list-item-title
                            >
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title class="font-weight-bold">
                                Status
                            </v-list-item-title>
                            <v-list-item-title>
                                {{ selectedRow.status }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title class="font-weight-bold">
                                Waktu Pembayaran
                            </v-list-item-title>
                            <v-list-item-title>
                                {{ selectedRow.transaction_payment_time }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title class="font-weight-bold">
                                Metode Pembayaran
                            </v-list-item-title>
                            <v-list-item-title>
                                {{ selectedRow.payment_method }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title class="font-weight-bold">
                                No Rekening
                            </v-list-item-title>
                            <v-list-item-title>
                                {{ selectedRow.payment_account }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title class="font-weight-bold">
                                Bank
                            </v-list-item-title>
                            <v-list-item-title>
                                {{ selectedRow.payment_company }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-card-text>
                </v-card>
            </template>
        </v-dialog>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
// import DataTable from "@/modules/global/components/plugins/DataTable-c";
import DataTableDropdown from "@/modules/global/components/plugins/DataTableDropdown";
import Moment from "moment";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global//components/plugins/Spinner";
import moment from "moment";

export default {
    name: "jadwalkelas",

    components: {
        "app-datatable": DataTableDropdown,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            isLoading: false,
            transaksiList: [],
            details: [],
            status: {
                PUBLISH: "PUBLISHED",
                UNPUBLISH: "UNPUBLISHED",
            },
            selectedRow: null,
            start_date: "",
            end_date: "",
            search: "",
            tableKey: "",
            sortBy: "",
            filters: "",
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            params: {
                search: "",
                order_id: null,
                email: null,
                sort: null,
                student_name: null,
                phone_number: null,
                package_name: null,
                group_name: null,
                package: null,
                group: null,
                status: null,
                transaction_payment_time: null,
                page: 1,
                nominal: null,
                per_page: 12,
                totalPages: 0,
                total_transaction: 0,
                sortMode: "desc",
                start_date: null,
                end_date: null,
                payment_company: "",
            },
            headers: [
                {
                    text: "Tanggal Transfer",
                    value: "transaction_payment_time",
                    width: 160,
                },
                { text: "Nama Siswa", value: "nama_siswa", width: 180 },
                { text: "Email", value: "email", width: 180 },
                { text: "Paket Group", value: "package_name", width: 170 },
                { text: "Nominal", value: "nominal", width: 150 },
                {
                    text: "Metode Pembayaran",
                    value: "payment_company",
                    width: 170,
                },
                { text: "Status", value: "status", width: 130 },
                { text: "Aksi", value: "data-table-expand" },
            ],
            headersKey: [
                "transaction_payment_time",
                "email",
                "nama_siswa",
                "package_name",
                "nominal",
                "payment_method",
                "status",
            ],
            filter_type: "ALL",
            menu: false,
            modal_date: false,
            modal_date2: false,
            date: "",
            date2: "",
            showModal: false,
            rowDetail: null,
        };
    },

    mounted: function () {
        this.fetchData();
    },

    watch: {
        "pagination.currentPage": function (val) {
            this.params.page = val;
            this.fetchData();
        },
        pagination: function () {
            this.params.sortMode = this.pagination.sortMode;
            this.fetchData();
        },
        // filter_type() {
        //   if (this.filter_type === "ALL") {
        //     this.date = "";
        //     this.date2 = "";
        //   }
        // },
    },

    methods: {
        fetchData: function () {
            var context = this;

            SalesService.getListTransaksi(context.params, function (result) {
                context.transaksiList = [];
                context.pagination.totalPages = parseInt(
                    result.data.total_transaction / context.pagination.perPage,
                );
                context.maxPage = parseInt(
                    result.data.total_transaction / context.pagination.perPage,
                );
                context.params.total_transaction =
                    result.data.total_transaction;
                // context.pagination.totalPages = result.data.maxPage;

                if (result.success) {
                    result.data.list_transactions.forEach(
                        function (content, index) {
                            if (content.transaction_payment_time !== null) {
                                content.transaction_payment_time = Moment(
                                    content.transaction_payment_time,
                                ).format("YYYY-MM-DD HH:mm");
                            }

                            var row = {
                                no: index,
                                id: content.order_id,
                                order_id: content.order_id,
                                email: content.email,
                                nama_siswa: content.nama_siswa,
                                handphone: content.handphone,
                                package_name: content.paket,
                                group_name: content.group,
                                nominal: content.nominal,
                                status: content.status,
                                school: content.school,
                                payment_account: content.payment_account,
                                payment_company: content.payment_company,
                                payment_method: content.payment_method,
                                transaction_payment_time:
                                    content.transaction_payment_time,
                                transaction_expired_time:
                                    content.transaction_expired_time,
                            };

                            context.transaksiList.push(row);
                        },
                    );
                    context.isLoading = false;
                } else {
                    alert("Terjadi kesalahan : " + result.message);
                    context.isLoading = false;
                }
            });
        },
        doFilter() {
            var context = this;
            this.menu = false;

            if (this.filter_type === "ALL") {
                context.date = null;
                context.date2 = null;

                context.params.start_date = context.date;
                context.params.end_date = context.date2;
            } else {
                context.params.start_date = Moment(context.date).format(
                    "YYYY-MM-DD",
                );
                context.params.end_date = Moment(context.date2).format(
                    "YYYY-MM-DD",
                );
            }

            context.fetchData();
        },
        doSearch() {
            this.params.page = 1;
            this.pagination.currentPage = 1;

            if (!this.search.by || !this.search.query) {
                this.clearFilter();
            } else {
                this.params[this.search.by] = this.search.query;
            }

            if (this.search.by === "status") {
                this.params.status = this.search.query.toUpperCase();
            } else if (this.search.by === "transaction_payment_time") {
                this.params.transaction_payment_time = Moment(
                    this.search.query,
                ).format("YYYY-MM-DD");
                this.params.start_date = this.params.transaction_payment_time;
                this.params.end_date = this.params.transaction_payment_time;
            } else if (this.search.by === "nominal") {
                this.params.nominal = parseInt(this.search.query);
            } else if (this.search.by === "payment_company") {
                this.params.payment_company = this.search.query;
            }

            this.fetchData();
        },

        clearFilter() {
            this.params = {
                search: "",
                order_id: null,
                email: null,
                sort: null,
                student_name: null,
                phone_number: null,
                package: null,
                group: null,
                page: 1,
                per_page: 12,
                totalPages: 0,
                total_transaction: 0,
                sortMode: "desc",
            };
        },

        updateProduk: function () {
            var context = this;
            var produkId = this.selectedRow.id;
            SalesService.getDetailTransaksi(produkId, function (result) {
                context.isLoading = false;

                if (result.success) {
                    context.selectedRow = {
                        id: result.data.order_id,
                        email: result.data.email,
                        nama_siswa: result.data.nama_siswa,
                        handphone: result.data.handphone,
                        paket: result.data.paket,
                        group: result.data.group,
                        nominal: result.data.nominal,
                        status: result.data.status,
                        school: result.data.school,
                        payment_account: result.data.payment_account,
                        payment_company: result.data.payment_company,
                        payment_method: result.data.payment_method,
                        transaction_payment_time:
                            result.data.transaction_payment_time,
                        transaction_expired_time:
                            result.data.transaction_expired_time,
                    };

                    if (context.selectedRow.transaction_payment_time) {
                        context.selectedRow.transaction_payment_time = Moment(
                            context.selectedRow.transaction_payment_time,
                        ).format("DD MMMM, YYYY h:mm");
                        context.selectedRow.transaction_expired_time = Moment(
                            context.selectedRow.transaction_expired_time,
                        ).format("DD MMMM, YYYY h:mm");
                    }

                    // context.showModal = true;
                } else {
                    alert("Terjadi Kesalahan : " + result.message);
                }
            });
        },

        updateAllProdukStatus: function (status) {
            var context = this;
            var confirmed = window.confirm(
                "Apakah anda yakin akan mengupdate semua status produk?",
            );

            if (confirmed) {
                this.isLoading = true;
                SalesService.updateAllProdukStatus(status, function (result) {
                    context.isLoading = false;

                    if (result.success) {
                        alert("Data Terupdate");
                        context.fetchData();
                    } else {
                        alert("Terjadi Kesalahan : " + result.message);
                    }
                });
            }
        },

        deleteProduk: function (produk) {
            var context = this;
            var produkId = produk.id;
            var confirmed = window.confirm(
                "Apakah anda yakin akan menghapus jadwal ini?",
            );

            if (confirmed) {
                this.isLoading = true;
                SalesService.hapusPaket(produkId, function (result) {
                    context.isLoading = false;
                    if (result.success) {
                        alert("Data Terhapus");
                        context.fetchData();
                    } else {
                        alert("Terjadi Kesalahan : " + result.message);
                    }
                });
            }
        },

        convertToRupiah: function (value) {
            var rupiah = "";
            var angkarev = value.toString().split("").reverse().join("");

            for (var i = 0; i < angkarev.length; i++)
                if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
            return (
                "Rp " +
                rupiah
                    .split("", rupiah.length - 1)
                    .reverse()
                    .join("")
            );
        },

        loadDetailExpanded(row) {
            // alert(JSON.stringify(row));
            var context = this;
            var produkId = row.item.id;
            SalesService.getDetailTransaksi(produkId, function (result) {
                context.isLoading = false;

                if (result.success) {
                    context.selectedRow = {
                        id: result.data.order_id,
                        email: result.data.email,
                        nama_siswa: result.data.nama_siswaa,
                        handphone: result.data.handphone,
                        paket: result.data.paket,
                        group: result.data.group,
                        nominal: result.data.nominal,
                        status: result.data.status,
                        school: result.data.school,
                        payment_account: result.data.payment_account,
                        payment_company: result.data.payment_company,
                        payment_method: result.data.payment_method,
                        transaction_payment_time:
                            result.data.transaction_payment_time,
                        transaction_expired_time:
                            result.data.transaction_expired_time,
                    };

                    if (context.selectedRow.transaction_payment_time) {
                        context.selectedRow.transaction_payment_time = Moment(
                            context.selectedRow.transaction_payment_time,
                        ).format("DD MMMM, YYYY h:mm");
                        context.selectedRow.transaction_expired_time = Moment(
                            context.selectedRow.transaction_expired_time,
                        ).format("DD MMMM, YYYY h:mm");
                    }

                    context.rowDetail = context.selectedRow;
                } else {
                    alert("Terjadi Kesalahan : " + result.message);
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// Transaksi.vue?880c3856